import { merge } from '@gympass/yoga-common';
import tokens from '../global';
var negative = ['#DEF8E9', '#1E854A'];
var positive = ['#FCEAE9', '#CB3530'];
var colors = {
  positive: positive,
  negative: negative
};
export default merge(tokens, {
  colors: colors
});